import React from 'react';
import {PublisherSimilarBookListModel} from "../../../models/publisher/publisher-similar-book-list.model";
import {useHistory} from "react-router-dom";
import {Chip, Grid, Hidden, Tab, Tabs} from "@material-ui/core";
import styled from "styled-components";
import {Colors} from "../../../theme/colors";
import {CustomLinearProgress} from "../../custom-linear-progress/custom-linear-progress";
import EmptyLogo from "../../../img/empty-publisher-logo.png";
import {CustomTabPanel} from "../../ui-base/tab-panel";
import {StyledButton} from "../../ui-base/button";
import {PublisherSimilarBookMarketListModel} from "../../../models/publisher/publisher-similar-book-market-list.model";
import {SimilarBookListModel} from "../../../models/publisher/similar-book-list.model";
import {useTranslation} from "react-i18next";
import {BaseService} from "../../../services/base.service";
import {BookCover} from "../../shared/book-cover";

export const NewPublisherBookShort: React.FC<{manuscript: PublisherSimilarBookListModel|PublisherSimilarBookMarketListModel|SimilarBookListModel, market?: boolean, saveToBookmark?: Function, deleteFromBookmark?: Function, askForPermission?: Function, similarBook?: boolean}> = ({manuscript, market = false, saveToBookmark, deleteFromBookmark, askForPermission, similarBook = false}) => {
    const [tabActive, setTabActive] = React.useState(0);
    const history = useHistory();
    const { t } = useTranslation(['publisher', 'common']);

    const getStatusColor = (status: string) => {
        if (status === 'PubNotWant' || status === 'AutNotWant' || status === 'Failed') {
            return 'red';
        } else {
            return 'green';
        }
    }

    const goToDetails = (id: string) => {
        if (!market) {
            history.push('/publisher/manuscript/' + id);
        }
    }

    return (
        <PublisherBookContainer item xs={12} container direction={"row"}>
            <Hidden mdDown>
                <BookCover
                    title={manuscript.manuscript.title}
                    description={manuscript?.manuscript?.description}
                    author={manuscript?.author?.first_name + ' ' + manuscript?.author?.last_name}
                    isMarket={market}
                    clickAction={() => goToDetails(manuscript.id)}
                    showDiamondIcon={!similarBook && (manuscript as PublisherSimilarBookListModel|PublisherSimilarBookMarketListModel)?.reported_by_publisher}
                />
            </Hidden>

            <Grid item container direction={"column"} xs>
                {!market && !similarBook &&
                <StyledStatusContainer item container direction={"row"} justifyContent={"space-between"}>

                    <Grid item xs>
                        <StyledStatus>{t('common:status')} <span
                            className={getStatusColor(manuscript.status)}>{t(`common:applicationStatus.status${manuscript.status}`)}</span></StyledStatus>
                    </Grid>

                    {manuscript.matching !== null && manuscript.matching >= 0 &&
                    <Grid item xs container direction={"row"} alignItems={"center"} justifyContent={"flex-end"}
                          spacing={1}>
                        <Grid item>
                            <StyledP>{t('publishBook.match')}</StyledP>
                        </Grid>

                        <Grid item style={{width: '200px'}}>
                            <CustomLinearProgress
                                value={BaseService.getMatchingValue(manuscript.matching)}
                            />
                        </Grid>

                        <StyledPercent item>
                            {/*{Math.round(manuscript.matching * 100)}%*/}
                        </StyledPercent>
                    </Grid>
                    }
                </StyledStatusContainer>
                }

                {similarBook &&
                <StyledStatusContainer item container direction={"row"} justifyContent={"space-between"} style={{paddingBottom: '10px'}}>
                    <Grid item xs container direction={"column"} spacing={1}>
                        <Grid item>
                            <StyledP>{t('publishBook.matchToPublisher')}</StyledP>
                        </Grid>

                        <Grid item style={{maxWidth: '300px'}}>
                            <CustomLinearProgress
                                value={BaseService.getMatchingValue(manuscript.matching)}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs container direction={"column"} spacing={1}>
                        <Grid item>
                            <StyledP>{t('publishBook.similarToPick')}</StyledP>
                        </Grid>

                        <Grid item style={{width: '300px'}}>
                            <CustomLinearProgress
                                value={manuscript.similarity * 100}
                            />
                        </Grid>
                    </Grid>
                </StyledStatusContainer>
                }

                <Grid item container direction={"row"} style={{margin: '20px 0'}}>
                    <StyledLeftGrid item sm={12} md={6} container direction={"column"} spacing={2}>
                        <Grid item>
                            <StyledH6 onClick={() => { goToDetails(manuscript.id) }} style={{cursor: (!market) ? 'pointer': 'default'}}>{manuscript.manuscript.title}</StyledH6>
                        </Grid>

                        {!market &&
                            <Grid item>
                                <StyledDate>{t('publishBook.sent')}: {manuscript.submitted_date ? new Date(manuscript.submitted_date).toLocaleString() : ''}</StyledDate>
                            </Grid>
                        }

                        <Grid item container direction={"row"} style={{display: 'flex', alignItems: 'center'}}>
                            <Grid item>
                                {/*<StyledAuthorImage src={manuscript.author.photo?.file || EmptyLogo}/>*/}
                                <StyledAuthorLogo style={{backgroundImage: `url(${manuscript.author.photo?.file || EmptyLogo})`}}/>
                            </Grid>

                            <Grid item>
                                <StyledAuthorName>{manuscript.author.first_name + ' ' + manuscript?.author?.last_name}</StyledAuthorName>
                            </Grid>
                        </Grid>

                        <Grid item>
                            <StyledSpan1>{t('publishBook.categories')}:</StyledSpan1>
                            <Grid container direction={'row'} spacing={1}>
                                {manuscript.manuscript.categories.filter((category, index: number) => index < 5).map((category) => (
                                    <Grid item key={category.id} style={{maxWidth: '100%'}}>
                                        <StyledCategoryChip size="small" label={category.name} style={{maxWidth: '100%'}} />
                                    </Grid>
                                ))}
                                {manuscript.manuscript.categories.length > 5 &&
                                <Grid item key={99999999} style={{maxWidth: '100%'}}>
                                    <StyledCategoryChip size="small" label={'...'} style={{maxWidth: '100%'}} />
                                </Grid>
                                }
                            </Grid>
                        </Grid>

                        <Grid item>
                            <StyledSpan1>{t('publishBook.tags')}:</StyledSpan1>
                            <Grid container direction={'row'} spacing={1}>
                                {manuscript.manuscript.tags.filter((tag) => tag.tag_type === 'tag').filter((category, index: number) => index < 8).map((tag) => (
                                    <Grid item key={tag.id} style={{maxWidth: '100%'}}>
                                        <StyledTagChip size="small" label={tag.name} style={{maxWidth: '100%'}}/>
                                    </Grid>
                                ))}
                                {manuscript.manuscript.tags.filter((tag) => tag.tag_type === 'tag').length > 8 &&
                                <Grid item key={99999999} style={{maxWidth: '100%'}}>
                                    <StyledTagChip size="small" label={'...'} style={{maxWidth: '100%'}}/>
                                </Grid>
                                }
                            </Grid>
                        </Grid>
                    </StyledLeftGrid>

                    <Grid item sm={12} md={6} container direction={"column"} justifyContent={"space-between"} spacing={2}>
                        <Grid item>
                            <Tabs value={tabActive} onChange={(event, newValue) => { setTabActive(newValue) }}>
                                <Tab label={t('publishBook.part')} style={{fontSize: '0.9rem'}}/>
                                <Tab label={t('common:desc')} style={{fontSize: '0.9rem'}}/>
                            </Tabs>

                            <CustomTabPanel value={tabActive} index={0}>
                                <StyledDescription>{BaseService.cutText(manuscript.manuscript?.fragment || '-', 500)}</StyledDescription>
                            </CustomTabPanel>
                            <CustomTabPanel value={tabActive} index={1}>
                                <StyledDescription>{BaseService.cutText(manuscript.manuscript?.description || '-', 500)}</StyledDescription>
                            </CustomTabPanel>
                        </Grid>

                        <Grid item container justifyContent={"flex-end"}>
                            {!market &&
                            <StyledButton type={"button"} onClick={() => { history.push('/publisher/manuscript/' + manuscript.id) }}>{t('publishBook.detailsButton')}</StyledButton>
                            }

                            {market && manuscript.status !== 'AskAccess' && manuscript.status !== 'AcsDenied' &&
                                <>
                                    {!manuscript.publisher_bookmarked &&
                                    <StyledButton style={{marginRight: '1rem'}} type={"button"} color={'secondary'} onClick={() => {saveToBookmark()}}>{t('common:save')}</StyledButton>
                                    }
                                    {manuscript.publisher_bookmarked && deleteFromBookmark &&
                                    <StyledButton style={{marginRight: '1rem'}} type={"button"} color={'secondary'} onClick={() => {deleteFromBookmark()}}>{t('common:delete')}</StyledButton>
                                    }
                                    <StyledButton type={"button"} onClick={() => {askForPermission()}}>{t('publishBook.askAccess')}</StyledButton>
                                </>
                            }

                            {market && (manuscript as PublisherSimilarBookMarketListModel).status === 'AcsDenied' &&
                                <StyledPDenied>{t('publishBook.authorNotAccept')}</StyledPDenied>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </PublisherBookContainer>
    );
}

const PublisherBookContainer = styled(Grid)`
  border: 1px solid #E0E0E0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  margin-bottom: 20px;
`;

const StyledP = styled('p')`
  font-size: 0.9rem;
  font-weight: 500;
`;

const StyledStatus = styled('p')`
  font-size: 0.9rem;
  font-weight: 500;
  padding: 20px 0 15px;
  
  span {
    font-size: 0.8rem;
    padding: 2px 5px;
    border-radius: 10px;
    margin-left: 5px;
    
    &.green {
      border: 1px solid #B3DAC7;
      background-color: #EBF5F0;
      color: ${Colors.green};
    }
   
    &.red {
      background-color: #FFECEC;
      border: 1px solid #FFD7D7;
      color: ${Colors.dangerRedHover};
    }
  }
`;

const StyledStatusContainer = styled(Grid)`
  border-bottom: 1px solid #E0E0E0;
`;

const StyledDate = styled('p')`
  color: ${Colors.grayText};
  font-size: 0.8rem;
  font-weight: 400;
  margin-top: -10px;
`;

const StyledH6 = styled('h6')`
  font-size: 1.5rem;
  color: ${Colors.violet};
  font-weight: 600;
`;

const StyledAuthorLogo = styled('div')`
  height: 50px;
  width: 50px;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;

const StyledAuthorName = styled('p')`
  color: ${Colors.blue};
  font-weight: 500;
  padding: 0 0 12px 10px;
  word-break: break-word;
`

const StyledSpan1 = styled('span')`
  font-weight: 500;
  font-size: 0.9rem;
  color: ${Colors.grayText};
`;

const StyledCategoryChip = styled(Chip)`
  background-color: transparent;
  color: ${Colors.lightViolet};
`;

const StyledTagChip = styled(Chip)`
  background-color: #F5F5F5;
  color: #424242;
  border: 1px solid #C2C2C2;
`;

const StyledDescription = styled('p')`
  font-size: 0.9rem;
`;

const StyledLeftGrid = styled(Grid)`
  border-right: 1px solid #E0E0E0;
  border-bottom: 0;

  @media (max-width: 959px) {
    border-right: 0;
    border-bottom: 1px solid #E0E0E0;
  }
`;

const StyledPercent = styled(Grid)`
  font-size: 1.1rem;
  font-weight: 500;
`;

const StyledPDenied = styled('p')`
  color: ${Colors.red};
  font-weight: 500;
`;
